import { useSelector } from 'react-redux';

import { UnleashFeatureNames } from '../../modules/Unleash/featureNames';
import { getIsFeatureEnabled } from '../../selectors/features';
import { useGetFeatureEnabledForCountry } from './useGetFeatureEnabledForCountry';

const useIsWorkAddressEnabled = () => {
  const isWorkAddressEnabled = useSelector(state =>
    getIsFeatureEnabled(state, UnleashFeatureNames.allEmpCompanyAddress)
  );
  const { isWorkAddressEnabled: isWorkAddressEnabledForCountry } =
    useGetFeatureEnabledForCountry();

  return isWorkAddressEnabled && isWorkAddressEnabledForCountry;
};

export default useIsWorkAddressEnabled;
